enum Claims {
    userId,
    userName,
    userType,
    userRoles,
    nbf,
    exp,
    iss,
    aud
}

export {
    Claims
}
